import { ArticleHeading1, LinkButton } from '@cian/ui-kit';
import * as React from 'react';
import { ISpecialists } from '../../types/specialist';
import { SpecialistRedesign } from '../SpecialistRedesign/SpecialistRedesign';

import * as styles from './styles.css';

interface ISpecialistListRedesignProps {
  specialists: ISpecialists;
  onItemClick(): void;
}

export const SpecialistListRedesign: React.FC<ISpecialistListRedesignProps> = ({ specialists, onItemClick }) => {
  const { title, getSummary, url, urlTitle, isRoundPhoto, specialists: specialistsList } = specialists;

  return (
    <div className={styles['container']} data-testid="SpecialistListRedesign">
      <ArticleHeading1 as="h2">{title}</ArticleHeading1>
      <div className={styles['content']}>
        {specialistsList.map(specialist => (
          <div className={styles['grid-item']} key={specialist.id}>
            <SpecialistRedesign
              onClick={onItemClick}
              specialist={specialist}
              isRoundPhoto={isRoundPhoto}
              getSummary={getSummary}
            />
          </div>
        ))}
      </div>
      <LinkButton theme="fill_secondary" size="XS" href={url} onClick={onItemClick}>
        {urlTitle}
      </LinkButton>
    </div>
  );
};
